import React, { useState, createContext, useContext } from 'react';
import { Snackbar, Alert } from '@mui/material';

const SnackbarContext = createContext();

export const useSnackbar = () => useContext(SnackbarContext);

const CustomSnackbar = ({ children }) => {
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState("");
  const [status, setStatus] = useState("info");

  const handleTriggerSnackbar = (toastMessage, severity) => {
    setMessage(toastMessage);
    setStatus(severity);
    setOpen(true);
  };

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
  };

  return (
    <SnackbarContext.Provider value={{ handleTriggerSnackbar }}>
      {children}
      <Snackbar
        open={open}
        onClose={handleClose}
        autoHideDuration={3000}
        anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
        sx={{
          mt: 5,
          '& .MuiPaper-root': {
            padding: '8px 16px',
            borderRadius: '8px',
            boxShadow: 'none',
            fontFamily: 'Roboto, sans-serif',
            fontSize: '0.875rem',
            display: 'flex',
            alignItems: 'center',
          },
        }}
      >
        <Alert onClose={handleClose} severity={status} sx={{ width: "100%" }}>
          {message}
        </Alert>
      </Snackbar>
    </SnackbarContext.Provider>
  );
};

export default CustomSnackbar;
